import { type FC, memo } from 'react';
import { BlockLink } from 'BlockLink';
import { BottomAlignedWithButton } from '../BottomAlignedWithButton';
import { StartDiscussionButton } from '../StartDiscussionButton/StartDiscussionButton';
import { type SupportedColors } from '../../TutorBotVoiceAgent.types';

type Props = {
    onStartDiscussionClick: () => void;

    // See comment at the top of PostDiscission about how it's a bit odd that we've implemented
    // the StartScreen and PostDiscussion in different ways.
    cardHeader?: string;
    cardTexts?: string[];
    introMessages: string[];
    introWidth?: 'full' | '669';
    abortFromRoom: (() => void) | null;
    abortText: string;
    color?: SupportedColors;
    startDiscussionText?: string | null;
};

const StartScreenComponent: FC<Props> = ({
    onStartDiscussionClick,
    cardHeader,
    cardTexts,
    introMessages,
    introWidth,
    // See comments about "abort" props in LiveKitRoomConversation Props definition
    abortFromRoom,
    abortText,
    color,
    startDiscussionText,
}) => (
    <BottomAlignedWithButton
        type="intro"
        cardHeader={cardHeader}
        cardTexts={cardTexts}
        introMessages={introMessages}
        introWidth={introWidth}
        Button={<StartDiscussionButton onPress={onStartDiscussionClick} color={color} content={startDiscussionText} />}
        Bottom={
            abortFromRoom && (
                <BlockLink onPress={abortFromRoom} color="slate-grey">
                    {abortText}
                </BlockLink>
            )
        }
    />
);

export const StartScreen = memo(StartScreenComponent) as typeof StartScreenComponent;
